// extracted by mini-css-extract-plugin
module.exports = {"formForgotPassword":"styles_formForgotPassword__J8jUG"};